module.exports = __webpack_public_path__ + "da6f471cd32f320b16359c7fe21b6339.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/email.svg
// module id = 2813
// module chunks = 1